export const trimString = (str: string): string => {
    const trimmedString = str.replace(/\s+/g, '');
    return trimmedString;
};
